<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search >
        <search-box class="search-box">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="80px" size="mini">
           
            <el-form-item label="经销商名称" prop="customerName">
              <el-input v-model="searchForm.customerName"></el-input>
            </el-form-item>
            <el-form-item label="商户号" prop="merNo">
              <el-input v-model="searchForm.merNo"></el-input>
            </el-form-item>
            <el-form-item label="商户名称" prop="shopName">
              <el-input v-model="searchForm.shopName"></el-input>
            </el-form-item>
            <el-form-item label="操作时间" prop="updatedTime">
              <q-date-picker v-model="searchForm" :isDefault="false" startFiled="updateDateStart" endFiled="updateDateEnd"  ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="newAdd">新增</el-button>
          <el-button type="primary" size="small" @click="importFile">导入</el-button>
          <el-button type="primary" size="small" @click="exportFile">导出</el-button>
        </template>
        <el-table stripe v-loading="loading" ref="tableRef" border highlight-current-row :data="tableData" :height="maxTableHeight">
          <el-table-column prop="customerName" label="经销商名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="regMerType" label="主体类型" show-overflow-tooltip width="90"></el-table-column>
          <el-table-column prop="shopName" label="商户名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="merNo" label="商户号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="merNoWithdraw" label="代付编码" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="legalName" label="法人" width="80"  show-overflow-tooltip></el-table-column>
          <el-table-column prop="shopLic" label="统一信用代码" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="bankNo" label="银行卡号" width="130" show-overflow-tooltip></el-table-column>
          <el-table-column prop="bankName" label="开户银行全称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="updatedBy" label="操作人" width="110"></el-table-column>
          <el-table-column prop="updatedTime" label="操作时间" align="center"width="160"></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template v-slot="{row}">
              <el-link type="primary" :underline="false" @click="edit(row)">编辑</el-link>
              <el-link style="margin-left: 10px;" type="danger" :underline="false" @click="del(row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <add-dialog
      v-if="isShowAddDialog"
      :isShowAddDialog.sync="isShowAddDialog"
      :isEdit="isEdit"
      :newAddData="newAddData"
      @addSuccess="onSearch"
    />
    <import-dialog
      reportName="importOfflineCustomer" 
      v-if="isShowImport" 
      :visible.sync="isShowImport"
    />
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from 'moment';
import addDialog from "./components/add-dialog";
import importDialog from '@/views/import-export/import-dialog'
export default {
  mixins: [tableMixin,pagePathMixin],
  components: {
    addDialog,
    importDialog
  },
  data() {
    return {
      isShowImport: false,
      searchForm: {
        customerName: "",
        merNo: "",
        shopName: "",
        updateDateStart: "",
        updateDateEnd: ""
      },
      isEdit: false,
      newAddData: {},
      formData: {
        id: '',
        customerId: "",
        customerName: "",
        regMerType:"",
        shopName: "",
        merNo: "",
        merNoWithdraw: "",
        legalName: "",
        shopLic: "",
        bankNo: "",
        bankName: ""
      },

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      isShowAddDialog: false,
      changePayWayParams: {},
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.configure
        .queryOfflineUnionCustomerList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key == 'updateDateStart' || key == 'updateDateEnd') {
          if (val) {
            this.filterParam[key] = moment(val).format('YYYY-MM-DD');
          }
        }else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.updateDateEnd = "",
      this.searchForm.updateDateStart = "",
      this.$refs.dateRef.reset()
    },
    newAdd() {
      this.isEdit = false
      this.newAddData = JSON.parse(JSON.stringify(this.formData))
      this.isShowAddDialog = true; 
    },
    edit(row) {
      this.isEdit = true
      for(let [key,value] of Object.entries(this.formData)) {
        this.$set(this.newAddData,key,row[key])
      }
      this.isShowAddDialog = true
    },
    del(row) {
      this.$confirm('确定删除该条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning', 
      }).then(res => {
        this.$api.configure.deleteUnionOfflineCustomer(row.id).then(res => {
          this.$message.success('删除成功')
          this.onSearch()
        })
      })
    },
    importFile() {
      this.isShowImport = true; 
    },
    exportFile() {
      let params = {
        ...this.filterParam
      };
      this.$api.common.doExport('queryOfflineUnionCustomerList', params).then(() => {
        this.$message.success('导出操作成功，请前往导出记录查看详情');
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .date-input  {
    width 220px !important
  }
}
</style>
